module.exports = __webpack_public_path__ + "501e2e4f730daaf303fb201c5ae3e054.png";